import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { AngularEditorModule } from '@kolkov/angular-editor';
import { NgxDropzoneModule } from 'ngx-dropzone';
import { CoreModule } from 'src/app/components/fields/core.module';
import { ReportAnIssueComponent } from './components/report-an-issue/report-an-issue.component';
import { ReportAnIssueModalComponent } from './modals/report-an-issue-modal/report-an-issue-modal.component';
@NgModule({
    declarations: [
        ReportAnIssueModalComponent,
        ReportAnIssueComponent,
    ],
    imports: [
        CommonModule,
        FormsModule,
        CoreModule,
        AngularEditorModule,
        DragDropModule,
        NgxDropzoneModule
    ],
    exports: [ReportAnIssueComponent],
    providers: []
})

export class OfcModule { }
